var objChartTempHistory = {
    // <summary>
    // This object holds everything regarding the temp charts and the history of temp charts of the archive
    // </summary>

    _addHistoryButtons: function (me) {
        /// <summary>
        /// adds previous/next buttons to navigate through hisotry
        /// </summary>
        try {
            let obj = me.vcMenu.menu.main.history;
            
            if (me.settings.menu.main.history.enabled) {

                var prev = $("<div>").attr("id", "btn-prev").addClass("float box button-toggle inactive").attr("title", me.specific.resources.back).html("<i class='fa fa-arrow-left'></i>");
                var next = $("<div>").attr("id", "btn-next").addClass("float box button-toggle inactive").attr("title", me.specific.resources.next).html("<i class='fa fa-arrow-right'></i>");
                obj.append(prev, next);

                obj.on("click", "#btn-prev", function () {
                    me.history.current--;
                    me.status = JSON.parse(JSON.stringify(me.history.list[me.history.current]));
                    me._getSelectedSignals();
                    me._resetMenuFromStatus();
                    me.history.dirty = true;
                    me._reload();
                });
                obj.on("click", "#btn-next", function () {
                    me.history.current++;
                    me.status = JSON.parse(JSON.stringify(me.history.list[me.history.current]));
                    me._getSelectedSignals();
                    me._resetMenuFromStatus();
                    me.history.dirty = true;
                    me._reload();
                });
            }
        } catch (e) { me._writeErr(e); }
    },

    _handleHistory: function (me) {
        /// <summary>
        /// This function handles the history of the saved temp charts
        /// </summary>
        try {
            let obj = me.vcMenu.menu.main.history;
            var status = JSON.stringify(me.status);

            if (me.history.dirty == false) {
                let bAdd = false;
                if (me.history.list.length == 0) bAdd = true;
                if (!bAdd) if (JSON.stringify(me.history.list[me.history.list.length - 1]) !== status) bAdd = true;

                if (bAdd) {
                    me.history.list[me.history.list.length] = JSON.parse(status);
                    if (me.history.list.length == 1) {
                        me.history.list[me.history.list.length - 1].firstChoiceFilled = true;
                        me.history.list[me.history.list.length - 1].dirty.details = false;
                    }
                    me.history.current = me.history.list.length - 1;
                }
            }
            obj.find("#btn-prev").toggleClass("inactive", me.history.current < 1);
            obj.find("#btn-next").toggleClass("inactive", me.history.current == me.history.list.length - 1);
            me.history.dirty = false;

        } catch (e) { me._writeErr(e); }
    },

    _handleExperimentalTempCharts: function (me) {
        /// <summary>
        /// we build up the structure of the different parts
        /// </summary>
        try {
            let obj;

            if (me.settings.menu.main.rampTempCharts.enabled) {
                obj = me.vcMenu.menu.main.rampTempCharts;

                var add = $("<div>").attr("id", "btn-add-temp-chart").addClass("box button-toggle button-toggle-active vc-grid-margin-right").html("<i class='fa fa-plus'></i><br/>" + "").width(40);
                var container = $("<div>").attr("id", "div-add-temp-charts").html("");

                obj.append(add, container);


                add.on("click", function () {
                    var counter = me.tempCharts.length;
                    var bAdd = false;
                    if (counter == 0) bAdd = true;
                    if (!bAdd) if (JSON.stringify(me.tempCharts[counter - 1]) !== JSON.stringify(me.status)) bAdd = true;

                    if (bAdd) {
                        me.tempCharts[counter] = JSON.parse(JSON.stringify(me.status));
                        var tmp = $("<div>").attr("id", "icon-temp-chart-" + counter).data("counter", counter).addClass("box float button-toggle temp-chart").html(counter + 1);
                        container.append(tmp);
                    }
                });


                container.on("click", ".temp-chart", function () {
                    var counter = parseInt($(this).data("counter"));
                    var tmpChartId = 10000 + counter;

                    var show = $(this).hasClass("button-toggle-active");

                    if (show) {
                        $("#tmp-" + tmpChartId).hide();
                        $(this).removeClass("button-toggle-active");
                        me.currentTempChart = null;
                        return true;

                    } else {
                        if ($(this).hasClass("loaded")) {
                            $("#tmp-" + tmpChartId).show();
                            $(this).addClass("button-toggle-active");
                            me.currentTempChart = me.tempCharts[counter];
                            return true;
                        }
                    }

                    $(this).addClass("button-toggle-active");
                    $(this).addClass("loaded");

                    var myStatus = me.tempCharts[counter];
                    me.currentTempChart = myStatus;

                    var top = parseInt($(this).offset().top - 70);

                    //TODO: this function should also get refactored - same like dsEdit popup and chart click handler popup
                    var w, h;
                    //get the windows height for our popup
                    h = $(window).height();
                    if (h === 0) {
                        h = $(document).height();
                        if (h === 0) {
                            h = document.body.scrollHeight;
                        }
                    }
                    w = parseInt($(window).width() * 0.95);
                    h = h - top - 200;
                    //h = parseInt(h * 0.8);

                    var popup = $("<div>").attr("id", "tmp-" + tmpChartId).addClass("modal-popup-dialog");
                    popup.html($("<div>").attr("id", "btn-take-" + tmpChartId).data("counter", counter).addClass("btn-take").html(me.specific.resources.apply).button());
                    popup.append($("<div>").attr("id", "tmp-chart-" + tmpChartId).html(me.vcC.getLoadingIcon()));

                    popup.css("overflow-y", "hidden");

                    popup.width(w);
                    popup.height(h);
                    popup.css("top", top + "px");
                    popup.css("left", (w / 0.95 * 0.02) + "px");
                    popup.css("position", "absolute");
                    popup.css("z-index", 10001);
                    popup.css("padding", "12px");
                    me.vcMenu.obj.append(popup);
                    me._loadContent(myStatus, false, "tmp-chart-", tmpChartId, w - 24, h - 24);

                    return true;
                });

                me.element.on("click", ".btn-take", function () {
                    var counter = parseInt($(this).data("counter"));
                    var icon = me.fnd("#icon-temp-chart-" + counter);
                    var myStatus = me.tempCharts[counter];

                    $("#tmp-" + (10000 + counter)).hide();
                    icon.removeClass("button-toggle-active");

                    me.status = JSON.parse(JSON.stringify(myStatus));
                    me._getSelectedSignals();
                    me._resetMenuFromStatus();
                    me._reload();

                    me.currentTempChart = null;
                });
            }
        } catch (e) { me._writeErr(e); }
    },

    _cleanExperimentalTempCharts: function (me) {
        /// <summary>
        /// cleans everything of the temp charts
        /// </summary>
        try {
            me.tempCharts = [];
            me.currentTempChart = null;
            $("div[id*='icon-temp-chart-']").remove();
            $("div[id*='tmp-1000']").remove();
        } catch (e) { me._writeErr(e); }
    },

    _loadExperimentalTempCharts: function (me) {
        /// <summary>
        /// loads existing temp charts, which are saved in the status
        /// </summary>
        try {
            if (me.tempCharts.length > 0) {
                var container = me.fnd("#div-add-temp-charts");
                me.tempCharts.forEach(function (item, index) {

                    var tmp = $("<div>")
                        .attr("id", "icon-temp-chart-" + index)
                        .data("counter", index)
                        .addClass("box float button-toggle temp-chart")
                        .html(index + 1);

                    container.append(tmp);
                });
            }

        } catch (e) { me._writeErr(e); }
    }

};